module.exports = __webpack_public_path__ + "static/media/ar_left_mobile.46c63896.svg";